import clsx from "clsx";
import { FunctionComponent } from "react";

import LoopNav from "@ui/components/navigation/LoopNav";
import {
  hide,
  hideTabletPlus,
  showTabletPlus,
} from "@ui/shared-styles/layout.css";
import { useLoopNavComponentContext } from "@voxmedia/duet-context/context/loop-nav-context";

import * as styles from "./StickyNav.css";
import { StickyNavContentProps } from "./types";

interface Props extends StickyNavContentProps {
  forceOpenLoopNav?: boolean;
  commentCount?: React.ReactNode | null;
}

const StickyNavLoopNavContent: FunctionComponent<Props> = ({
  Logo,
  MinimalLogo,
  hamburgerButton,
  forceOpenLoopNav,
  commentCount,
}) => {
  const LoopNavComponent = useLoopNavComponentContext(LoopNav);

  return (
    <div className={clsx(styles.loopNavInnerContainer)}>
      <a
        href="/"
        aria-label="Click to visit the homepage"
        tabIndex={-1}
        className={styles.loopNavLogoContainer}
      >
        <Logo
          className={clsx(styles.logo, MinimalLogo && hide && showTabletPlus)}
        />
        {MinimalLogo && <MinimalLogo className={clsx(hideTabletPlus)} />}
      </a>
      <LoopNavComponent forceOpenLoopNav={forceOpenLoopNav} />
      <div className={clsx(styles.rightMenu, styles.loopNavRightMenu)}>
        {commentCount}
        {hamburgerButton}
      </div>
    </div>
  );
};

export default StickyNavLoopNavContent;
